import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router";

const Button = ({
  text = "Text",
  url = "#",
  type = "primary",
  icon = false,
  blank = false,
  className = "",
}) => {
  return (
    <Link
      to={url}
      target={blank ? "_blank" : "_self"}
      className={`${
        type === "primary"
          ? "bg-primary hover:text-primary text-white hover:bg-transparent"
          : type === "secondary"
            ? "text-primary hover:bg-primary bg-transparent hover:text-white"
            : "text-primary hover:text-primary cursor-not-allowed hover:bg-transparent"
      } ring-primary flex w-fit items-center rounded-2xl px-12 py-3 text-xl font-medium ring transition-all duration-200 xl:px-8 ${className}`}
    >
      {text}

      {icon && <FiArrowRight className="ms-2" />}
    </Link>
  );
};

export default Button;
